import useGuidebookRedirect from 'hooks/guidebook/useGuidebookRedirect';
import { useTranslation } from 'react-i18next';
import AsyncAccessLink from './AsyncAccessLink';

const GuidebooksAccessLink = () => {
  const { t } = useTranslation();
  const { redirectToGuidebook, isFetching } = useGuidebookRedirect();

  return (
    <AsyncAccessLink
      label={t('pageIntegrations.table.guidebooksAdmin')}
      onAccess={redirectToGuidebook}
      isFetching={isFetching}
    />
  );
};

export default GuidebooksAccessLink;
